<template>
  <div id="tabelaCertidoesWrapper">
    <b-table
      :fields="fields"
      :items="itens"
      :busy="tableBusy"
      hover
      no-border-collapse
      stacked="sm"
      responsive
    >
      <template v-slot:cell(acao)="row">
        <div class="actions-icons lgvert d-none d-sm-flex">
          <b-link class="text-dark" @click="editar(row.item)">
            <font-awesome-icon icon="pencil" />
            <div style="font-size: 12px">Editar</div>
          </b-link>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { Certidao } from "@/types/interno/certidoes-ugs/certidao";
import { fieldsItensAnalisados } from "@/types/interno/certidoes-ugs/fields-itens-analisados";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { PropType } from "vue/types/v3-component-props";

const CompProps = Vue.extend({
  name: "TabelaCertidoes",
  components: {},
  props: {
    itens: {
      type: Array as PropType<Certidao[]>,
      default: () => [],
    },
  },
});

@Component
export default class TabelaCertidoes extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = [...fieldsItensAnalisados];
  tableBusy = false;

  editar (item: Certidao): void {
    this.$emit("editarItem", item);
  }
}
</script>

<style scoped></style>
